import { Controller } from '@hotwired/stimulus'

// After a punch confirmation, return the kiosk to the employee grid on its own so
// it's ready for the next person without anyone tapping. A manual link is rendered
// too, for whoever doesn't want to wait.
export class KioskRedirectController extends Controller {
  static values = { url: String, delay: { type: Number, default: 3500 } }

  connect () {
    this.timeout = setTimeout(() => window.Turbo.visit(this.urlValue), this.delayValue)
  }

  disconnect () {
    clearTimeout(this.timeout)
  }
}
